import { IOAuthCredentialTypeInfo } from '../../../ts/ServerApi/types/IOAuthCredential';
import { IOAuthCredentialDisplayStrings, OAuthCredentialsService } from '../../../connectivity/services/OAuthCredentialsService';

function filter(credentialTypeInfo: IOAuthCredentialTypeInfo) {
  const displayStrings: IOAuthCredentialDisplayStrings = OAuthCredentialsService.getDisplayStrings(credentialTypeInfo.type);
  return displayStrings && displayStrings.displayName;
}

export const CredentialTypeFilter = {
  filter
};
